module.exports = __webpack_public_path__ + "img/6.e8138f54.svg";